export default {
  // Navigation
  nav_home: "Home",
  nav_products: "Products",
  nav_about: "About Us",
  nav_support: "Support",
  nav_contact: "Contact",

  // Hero Section
  hero_title: "Taishan Musical Instruments",
  hero_subtitle: "Premium Chinese Musical Instruments",
  hero_description: "Dedicated to high-quality brass instrument manufacturing since 1987",
  hero_cta: "Explore Products",

  // Products Section
  products_title: "Our Products",
  products_subtitle: "Professional brass instruments, crafted with excellence",
  product_trumpet: "Trumpet Series",
  product_trumpet_desc: "Professional brass instrument with bright, full tone, suitable for all performance occasions",
  product_trombone: "Trombone Series",
  product_trombone_desc: "Smooth slide action, wide range, preferred by professional orchestras",
  product_saxophone: "Saxophone Series",
  product_saxophone_desc: "Rich, mellow tone, perfect for jazz and classical music",
  product_horn: "French Horn Series",
  product_horn_desc: "Soft, warm tone, essential for symphony orchestras",
  product_clarinet: "Clarinet Series",
  product_clarinet_desc: "Classic woodwind instrument with clear, captivating tone",
  product_flute: "Flute Series",
  product_flute_desc: "Crisp, melodious tone, ideal for solo and ensemble performances",
  view_details: "View Details",

  // Product Catalog
  catalog_title: "Product Catalog Download",
  catalog_description: "Download the complete Taishan Instruments catalog for detailed product specifications",
  catalog_download: "Download Catalog",

  // About Section
  about_title: "About Us",
  about_subtitle: "Over 30 years of craftsmanship heritage",
  about_heading: "About Taishan Musical Instruments",
  about_p1: "Shandong Taishan Brass Instrument Manufacturing Co., Ltd. was established in 1987 and is a leading professional brass instrument manufacturer in China. Located in Shandong Province, the company has a modern production base and a professional R&D team.",
  about_p2: "In 2004, the company's products were tested by the Musical Instrument Quality Supervision and Inspection Center of the Ministry of Culture and all met national standards. In 2006, the company successfully became a direct review unit and was awarded the title of 'Strong Enterprise in China's Musical Instrument Industry'.",
  about_p3: "The company has passed ISO9001 quality system certification and ISO14001 environmental system certification. Products are exported to many countries and regions around the world and are trusted by music lovers and professional performers.",
  about_year: "Founded",
  about_series: "Product Series",

  // Timeline
  timeline_title: "Our Journey",
  timeline_1987: "Company established, focusing on brass instrument manufacturing",
  timeline_2001: "Became a member of China International Musical Instrument Exhibition",
  timeline_2004: "Products passed inspection by Ministry of Culture's Musical Instrument Quality Supervision Center, meeting national standards",
  timeline_2006: "Awarded 'Strong Enterprise in China's Musical Instrument Industry' title",
  timeline_2013: "Taishan brass instruments became a Chinese brand competing with internationally renowned brands",
  timeline_2019: "Awarded 'Specialized, Refined, Distinctive, and Innovative' SME title by Shandong Provincial Department of Science and Technology",

  // Support Section
  support_title: "Support & Service",
  support_subtitle: "Professional after-sales service system",
  support_quality: "Quality Assurance",
  support_quality_desc: "ISO9001 certified, every product undergoes rigorous testing",
  support_service: "After-sales Service",
  support_service_desc: "Professional after-sales team providing maintenance and consultation",
  support_maintenance: "Repair & Maintenance",
  support_maintenance_desc: "Professional instrument repair and maintenance services",
  support_guide: "User Guide",
  support_guide_desc: "Detailed usage instructions and maintenance guidelines",

  // FAQ
  faq_title: "Frequently Asked Questions",
  faq_q1: "How do I choose the right brass instrument?",
  faq_a1: "We recommend choosing based on your playing level, musical style, and budget. Beginners can opt for entry-level products, while professional performers can choose high-end series. Our customer service team can provide professional advice.",
  faq_q2: "What is the warranty period?",
  faq_a2: "Our products come with a one-year warranty. Quality issues under normal use will be repaired or replaced free of charge.",
  faq_q3: "How do I maintain brass instruments?",
  faq_a3: "We recommend cleaning the instrument interior after each use, regularly oiling valves and slides, avoiding collisions and extreme temperatures. Please refer to the product manual for detailed maintenance guidelines.",
  faq_q4: "Do you offer international shipping?",
  faq_a4: "Yes, our products are sold to many countries and regions worldwide. Please contact our sales team for specific shipping methods and costs.",

  // Contact Section
  contact_title: "Contact Us",
  contact_subtitle: "We look forward to hearing from you",
  contact_info: "Contact Information",
  contact_address: "Address",
  contact_address_value: "Shandong Province, China",
  contact_phone: "Phone",
  contact_phone_value: "+65 91791835",
  contact_whatsapp: "WhatsApp",
  contact_whatsapp_value: "+65 91791835",
  contact_whatsapp_button: "Chat on WhatsApp",
  contact_email: "Email",
  contact_email_value: "Please leave a message through the form, we will reply as soon as possible",
  contact_hours: "Business Hours",
  contact_hours_value: "Monday to Friday 9:00-18:00",
  contact_form_title: "Leave a Message",
  contact_form_name: "Name",
  contact_form_email: "Email",
  contact_form_phone: "Phone",
  contact_form_message: "Message",
  contact_form_submit: "Submit",
  contact_form_name_placeholder: "Please enter your name",
  contact_form_email_placeholder: "Please enter your email",
  contact_form_phone_placeholder: "Please enter your phone number",
  contact_form_message_placeholder: "Please enter your message (max 500 characters)",
  contact_form_required: "Required",
  contact_form_success: "Submitted successfully! We will contact you soon.",
  contact_form_error: "Submission failed, please try again later.",
  contact_form_validate_required: "Please fill in all required fields",
  contact_form_validate_email: "Please enter a valid email address",
  contact_form_validate_message: "Message cannot exceed 500 characters",

  // Footer
  footer_description: "Dedicated to high-quality brass instrument manufacturing, providing excellent products for music lovers and professional performers.",
  footer_quick_links: "Quick Links",
  footer_contact_us: "Contact Us",
  footer_address: "Address: Shandong Province, China",
  footer_hours: "Business Hours: Monday to Friday 9:00-18:00",
  footer_copyright: "All rights reserved.",
  footer_powered: "Powered by Readdy"
};
